export const SupplierHomePath = '/supplier';
export const SupplierAttentionPath = '/supplier/attention';
export const CustomerListPath = '/customers';
export const CustomerAddPath = '/customers/add';
export const CustomerEditPath = {
  path: '/customers/:customerId',
  withId: (id: string): string => {
    return CustomerEditPath.path.replace(':customerId', id);
  },
};
export const CustomerStoreListPath = {
  path: '/customers/:customerId/stores',
  withCustomerId: (customerId: string): string => {
    return CustomerStoreListPath.path.replace(':customerId', customerId);
  },
};
export const CustomerStoreAddPath = {
  path: '/customers/:customerId/stores/add',
  withCustomerId: (customerId: string): string => {
    return CustomerStoreAddPath.path.replace(':customerId', customerId);
  },
};
export const CustomerStoreEditPath = {
  path: '/customers/:customerId/stores/:storeId',
  withParams: (customerId: string, storeId: string): string => {
    return CustomerStoreEditPath.path
      .replace(':customerId', customerId)
      .replace(':storeId', storeId);
  },
};
export const SupplierSettingsPath = {
  profile: '/settings/profile',
  address: '/settings/address',
  businessAddress: '/settings/business-address',
  language: '/settings/language',
  currency: '/settings/currency',
  notification: '/settings/notifications',
  password: '/settings/password',
};
